"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var Div = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 13px;\n  font-weight: bold;\n  text-align: ", ";\n"], ["\n  font-size: 13px;\n  font-weight: bold;\n  text-align: ", ";\n"])), function (_a) {
    var align = _a.align;
    return align;
});
var Status = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n"])), function (_a) {
    var theme = _a.theme, color = _a.color;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_400);
});
var Value = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  display: block;\n  font-size: 13px;\n  font-weight: lighter;\n"], ["\n  color: ", ";\n  display: block;\n  font-size: 13px;\n  font-weight: lighter;\n"])), function (_a) {
    var theme = _a.theme, valueColor = _a.valueColor;
    return utils_1.parseThemePath(valueColor, theme, colors_1.colors.GREY_400);
});
var AXSTicketStatus = function (_a) {
    var align = _a.align, status = _a.status, color = _a.color, value = _a.value, valueColor = _a.valueColor, theme = _a.theme, className = _a.className;
    return (React.createElement(Div, { className: classnames_1.default(['c-axs-ticket-status', className]), align: align, theme: theme },
        React.createElement(Status, { className: "c-axs-ticket-status__status", color: color }, status),
        React.createElement(Value, { valueColor: valueColor, className: "c-axs-ticket-status__value" }, value)));
};
AXSTicketStatus.defaultProps = {
    align: 'right',
    color: colors_1.colors.GREY_400,
    valueColor: colors_1.colors.GREY_400,
};
exports.default = AXSTicketStatus;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map